import produce from 'immer';

import {
  DASHBOARD_FETCH_FAILURE,
  DASHBOARD_FETCH_SUCCESS,
  EDIT_CMN_FAILURE,
  EDIT_CMN_SUCCESS,
  GET_QUEUED_NOTICES_SUCCESS,
} from '@actions/dashboard';

const initialState: IDashboardStore = {
  data: null,
  error: null,
  queuedNotices: null,
};

export default (state: IDashboardStore = initialState, action: any) =>
  produce(state, (draftState: IDashboardStore) => {
    switch (action.type) {
      case DASHBOARD_FETCH_SUCCESS:
        draftState.error = null;
        draftState.data = action.response;

        return;

      case DASHBOARD_FETCH_FAILURE:
        draftState.error = action.error;

        return;

      case GET_QUEUED_NOTICES_SUCCESS:
        draftState.queuedNotices = action.response;

        return;

      case EDIT_CMN_SUCCESS:
        draftState.error = null;
        draftState.data = action.response;

        return;

      case EDIT_CMN_FAILURE:
        draftState.error = action.error;

        return;
    }
  });
